import { Box, Typography } from "@mui/material";

const BANK_LOGO_FRAME_PX = 40;

/**
 * MUI Autocomplete renderOption: hiển thị logo ngân hàng + nhãn tài khoản.
 * Option shape: { value, label, logo? }
 */
export function renderBankAccountAutocompleteOption(props, option) {
  if (option == null) return null;
  const { key, ...optionProps } = props;
  const logo = option.logo;

  return (
    <Box
      component="li"
      key={key ?? option.value}
      {...optionProps}
      sx={{
        display: "flex !important",
        alignItems: "center",
        gap: 1.25,
        py: 0.75,
      }}
    >
      {logo ? (
        <Box
          sx={{
            width: BANK_LOGO_FRAME_PX,
            height: BANK_LOGO_FRAME_PX,
            flexShrink: 0,
            boxSizing: "border-box",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "background.paper",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt=""
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
            sx={{
              width: "100%",
              height: "100%",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>
      ) : (
        <Box sx={{ width: BANK_LOGO_FRAME_PX, height: BANK_LOGO_FRAME_PX, flexShrink: 0 }} />
      )}
      <Typography
        variant="body2"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
          minWidth: 0,
        }}
      >
        {option.label ?? ""}
      </Typography>
    </Box>
  );
}
